import { Client } from '@stomp/stompjs';
import SockJS from 'sockjs-client';

class NetClient {
  constructor(serverUrl, token) {
    this.serverUrl = serverUrl;
    this.token = token;
    this.stompClient = null;
    this.isConnected = false;
    this.subscriptions = new Map();
  }

  /**
   * 连接到服务器
   * @returns {Promise<void>}
   */
  async connect() {
    if (this.isConnected) {
      return Promise.resolve();
    }

    return new Promise((resolve, reject) => {
      this.stompClient = new Client({
        reconnectDelay: 2000,
        heartbeatOutgoing: 2000,

        webSocketFactory: () => {
          return new SockJS(this.serverUrl);
        },

        onConnect: (frame) => {
          this.isConnected = true;
          resolve();
        },

        onStompError: (frame) => {
          this.isConnected = false;
          reject(new Error(`STOMP Error: ${frame.headers.message}`));
        },

        onWebSocketError: (error) => {
          this.isConnected = false;
          reject(error);
        },

        onDisconnect: () => {
          this.isConnected = false;
        },
        // 日志
        debug: function (str) {
          console.log(`[${new Date().toISOString()}] STOMP: ${str}`);
        }
      });

      this.stompClient.activate();
    });
  }

  /**
   * 发送消息
   * @param {string} destination - 目标地址
   * @param {*} data - 要发送的数据
   * @returns {Promise<void>}
   */
  async send(destination, data) {
    if (!this.isConnected) {
      throw new Error('Not connected');
    }

    const body = typeof data === 'string' ? data : JSON.stringify(data);
    this.stompClient.publish({
      destination,
      body,
      headers: {
        'Authorization': `Bearer ${this.token}`,
        'priority': '9'
      }
    });
  }

  /**
   * 接收消息（订阅主题）
   * @param {string} topic - 订阅的主题
   * @param {Function} handler - 消息处理函数
   * @returns {Function} 取消订阅函数
   */
  subscribe(topic, handler) {
    if (!this.isConnected) {
      throw new Error('Not connected');
    }

    console.info(`subscribe: ${topic}`)
    const subscription = this.stompClient.subscribe(topic, (message) => {
      let data;
      try {
        data = JSON.parse(message.body);
      } catch (e) {
        data = message.body;
      }
      handler(data);
    });

    this.subscriptions.set(topic, subscription);

    // 返回取消订阅函数
    return () => {
      subscription.unsubscribe();
      this.subscriptions.delete(topic);
    };
  }

  /**
   * 断开连接
   */
  disconnect() {
    if (this.stompClient) {
      this.stompClient.deactivate();
    }
    this.isConnected = false;
    this.subscriptions.clear();
  }

  /**
   * 获取连接状态
   */
  connected() {
    return this.isConnected;
  }
}

export default NetClient;